module.exports = __webpack_public_path__ + "static/media/alert.7285bcc5.mp3";